import React, {useEffect} from "react";
import * as css from "./css/menu";
import menuListList from "./data/menu-list-list";
import {observer} from "mobx-react";
import QrCodeEnum from "enum/QrCodeEnum";
import {useHistory} from "react-router-dom";
import Router from "router/router";
import useMyStores from "hooks/useMyStores";

function Menu(props) {
    const {className} = props;
    const history = useHistory();
    const {qrCode, app, login, user} = useMyStores();

    useEffect(() => {
        qrCode.fetchList();
    }, []);

    const renderMenu = () => {
        return menuListList.map((list, listIndex) => {
            return (
                <css.li key={listIndex}>
                    {list.map((menu, index) => {
                        const {title, level, needLogin, location} = menu;

                        const onClick = () => {
                            if (location) {
                                history.push(location);
                            } else if (title === "浏览记录") {
                                if (!user.token) {
                                    login.show = true;
                                } else {
                                    window.open(
                                        Router.basename + Router.User.path + "?currentIndex=4"
                                    );
                                }
                            } else if (title === "我的收藏") {
                                if (!user.token) {
                                    login.show = true;
                                } else {
                                    window.open(
                                        Router.basename + Router.User.path + "?currentIndex=2"
                                    );
                                }
                            }
                        };

                        if (level === 1) {
                            return (
                                <css.Title1
                                    key={index}
                                    onClick={() => {
                                        onClick();
                                    }}
                                >
                                    {title}
                                </css.Title1>
                            );
                        } else if (level === 2) {
                            return (
                                <css.Title2
                                    key={index}
                                    onClick={() => {
                                        onClick();
                                    }}
                                >
                                    {title}
                                </css.Title2>
                            );
                        } else {
                            return <></>
                        }
                    })}
                </css.li>
            );
        });
    };

    const renderQrCodeList = () => {
        let {list} = qrCode;

        return list.filter(item => !!item.img)
            .map((item, i) => {
                const {id, img, type} = item;
                let title = app.app.websiteName;

                if (type === QrCodeEnum.WEB_QR_CODE.value) {
                } else if (type === QrCodeEnum.APP_QR_CODE.value) {
                    title += "的app";
                } else if (type === QrCodeEnum.MINI_APP_QR_CODE.value) {
                    title += "的小程序";
                }

                return (
                    <div className="qr-code-wrapper" key={i}>
                        <div className="qr-code-block">
                            <img key={id} id={id} src={img} alt="" className="qr-code"/>
                            <div className="bg"></div>
                        </div>
                        <div className="title">
                            {title}
                            <div className="top-decorate"></div>
                            <div className="bottom-decorate"></div>
                        </div>
                    </div>
                );
            });
    };

    return (
        <css.Menu className={className}>
            <css.Container>
                <css.Ul>{renderMenu()}</css.Ul>
                <css.QrCodeList>{app.app && renderQrCodeList()}</css.QrCodeList>
            </css.Container>
        </css.Menu>
    );
}

export default observer(Menu)
